import React, { useState } from "react";
import { Rating } from "react-simple-star-rating";
import useLocalStorage from "../../Hooks/useLocalStorage";

import axios from "axios";

export default function Froid() {
	const [choice, setChoice] = useState();
	const [choice2, setChoice2] = useState();

	const [rating, setRating] = useState(0);
	const [rating2, setRating2] = useState(0);

	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const userID = urlParams.get("id");
	const userName = urlParams.get("name");
	const formation = urlParams.get("formation");

	const [elementsUtiles, setElementsUtiles] = useState("");
	const [prolongements, setProlongements] = useState("");
	const [remarques, setRemarques] = useState("");

	const [sent, setSent] = useLocalStorage("completedFroid", false);

	var tooltipArr = [
		"Pas du tout",
		"Insuffisamment",
		"Moyennement",
		"En partie",
		"Totalement",
	];

	const sendForm = async e => {
		e.preventDefault();

		var avis1;
		var avis2;

		if (rating === 20) {
			avis1 = "Pas du tout";
		}

		if (rating === 40) {
			avis1 = "Insuffisamment";
		}

		if (rating === 60) {
			avis1 = "Moyennement";
		}

		if (rating === 80) {
			avis1 = "En partie";
		}

		if (rating === 100) {
			avis1 = "Totalement";
		}

		if (rating2 === 20) {
			avis2 = "Pas du tout";
		}

		if (rating2 === 40) {
			avis2 = "Insuffisamment";
		}

		if (rating2 === 60) {
			avis2 = "Moyennement";
		}

		if (rating2 === 80) {
			avis2 = "En partie";
		}

		if (rating2 === 100) {
			avis2 = "Totalement";
		}

		try {
			axios.post("https://global-academie.herokuapp.com/avis/froid", {
				userID,
				userName,
				formation,
				enPratique: choice,
				application: choice2,
				efficacite: avis1,
				valeur: avis2,
				elementsUtiles,
				prolongements,
				remarques,
			});
			setSent(true);
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<div className="flex min-h-screen w-full flex-col items-center justify-center">
			<form
				onSubmit={sendForm}
				className="my-16 flex w-full flex-col items-center justify-center px-4 md:w-1/2 md:px-0"
			>
				<h2 className="flex w-full items-center justify-between text-3xl font-bold text-indigo-500">
					Evaluation
				</h2>
				<hr className="my-4 h-[3px] w-[100px] self-start border-none bg-indigo-200" />
				<div
					className={
						sent
							? "hidden"
							: "flex w-full flex-col items-center justify-center space-y-7"
					}
				>
					<div className="w-full">
						<label
							className="mt-2 pl-1 text-xl font-semibold underline dark:text-indigo-200"
							htmlFor="contrat"
						>
							Avez vous pu mettre en pratique les connaissances
							acquises ?
						</label>
						<div className="my-8 flex w-full flex-wrap items-center gap-5">
							<button
								type="button"
								onClick={() => setChoice("Oui, tout le temps")}
								className={
									choice === "Oui, tout le temps"
										? "min-w-[200px] max-w-[550px] rounded-md border-2 border-transparent bg-indigo-500 p-2 font-medium text-white transition-all duration-200"
										: "min-w-[200px] max-w-[550px] rounded-md border-2 border-indigo-500 p-2 font-medium transition-all duration-200 hover:border-transparent hover:bg-indigo-500 hover:text-white"
								}
							>
								Oui, tout le temps
							</button>
							<button
								type="button"
								onClick={() => setChoice("Oui, régulièrement")}
								className={
									choice === "Oui, régulièrement"
										? "min-w-[200px] max-w-[550px] rounded-md border-2 border-transparent bg-indigo-500 p-2 font-medium text-white transition-all duration-200"
										: "min-w-[200px] max-w-[550px] rounded-md border-2 border-indigo-500 p-2 font-medium transition-all duration-200 hover:border-transparent hover:bg-indigo-500 hover:text-white"
								}
							>
								Oui, régulièrement
							</button>
							<button
								type="button"
								onClick={() =>
									setChoice("Oui, occasionnellement")
								}
								className={
									choice === "Oui, occasionnellement"
										? "min-w-[200px] max-w-[550px] rounded-md border-2 border-transparent bg-indigo-500 p-2 font-medium text-white transition-all duration-200"
										: "min-w-[200px] max-w-[550px] rounded-md border-2 border-indigo-500 p-2 font-medium transition-all duration-200 hover:border-transparent hover:bg-indigo-500 hover:text-white"
								}
							>
								Oui, occasionnellement
							</button>
							<button
								type="button"
								onClick={() =>
									setChoice(
										"Non l'opportunité ne s'est pas présentée"
									)
								}
								className={
									choice ===
									"Non l'opportunité ne s'est pas présentée"
										? "min-w-[200px] max-w-[550px] rounded-md border-2 border-transparent bg-indigo-500 p-2 font-medium text-white transition-all duration-200"
										: "min-w-[200px] max-w-[550px] rounded-md border-2 border-indigo-500 p-2 font-medium transition-all duration-200 hover:border-transparent hover:bg-indigo-500 hover:text-white"
								}
							>
								Non l'opportunité ne s'est pas présentée
							</button>
							<button
								type="button"
								onClick={() =>
									setChoice(
										"Non la formation n'était pas adaptée au besoin"
									)
								}
								className={
									choice ===
									"Non la formation n'était pas adaptée au besoin"
										? "min-w-[200px] max-w-[550px] rounded-md border-2 border-transparent bg-indigo-500 p-2 font-medium text-white transition-all duration-200"
										: "min-w-[200px] max-w-[550px] rounded-md border-2 border-indigo-500 p-2 font-medium transition-all duration-200 hover:border-transparent hover:bg-indigo-500 hover:text-white"
								}
							>
								Non la formation n'était pas adaptée au besoin
							</button>
						</div>
					</div>

					<div className="w-full">
						<label
							className="mt-2 pl-1 text-xl font-semibold underline dark:text-indigo-200"
							htmlFor="contrat"
						>
							L'application concrète des connaissances vous
							paraît-elle ?
						</label>
						<div className="my-8 flex w-full flex-wrap items-center gap-5">
							<button
								type="button"
								onClick={() => setChoice2("Facile")}
								className={
									choice2 === "Facile"
										? "min-w-[200px] max-w-[550px] rounded-md border-2 border-transparent bg-indigo-500 p-2 font-medium text-white transition-all duration-200"
										: "min-w-[200px] max-w-[550px] rounded-md border-2 border-indigo-500 p-2 font-medium transition-all duration-200 hover:border-transparent hover:bg-indigo-500 hover:text-white"
								}
							>
								Facile
							</button>
							<button
								type="button"
								onClick={() =>
									setChoice2("Difficile mais je m'en sors")
								}
								className={
									choice2 === "Difficile mais je m'en sors"
										? "min-w-[200px] max-w-[550px] rounded-md border-2 border-transparent bg-indigo-500 p-2 font-medium text-white transition-all duration-200"
										: "min-w-[200px] max-w-[550px] rounded-md border-2 border-indigo-500 p-2 font-medium transition-all duration-200 hover:border-transparent hover:bg-indigo-500 hover:text-white"
								}
							>
								Difficile mais je m'en sors
							</button>
							<button
								type="button"
								onClick={() =>
									setChoice2(
										"Difficile, il me faudrait de l'aide"
									)
								}
								className={
									choice2 ===
									"Difficile, il me faudrait de l'aide"
										? "min-w-[200px] max-w-[550px] rounded-md border-2 border-transparent bg-indigo-500 p-2 font-medium text-white transition-all duration-200"
										: "min-w-[200px] max-w-[550px] rounded-md border-2 border-indigo-500 p-2 font-medium transition-all duration-200 hover:border-transparent hover:bg-indigo-500 hover:text-white"
								}
							>
								Difficile, il me faudrait de l'aide
							</button>
							<button
								type="button"
								onClick={() => setChoice2("Trop difficile")}
								className={
									choice2 === "Trop difficile"
										? "min-w-[200px] max-w-[550px] rounded-md border-2 border-transparent bg-indigo-500 p-2 font-medium text-white transition-all duration-200"
										: "min-w-[200px] max-w-[550px] rounded-md border-2 border-indigo-500 p-2 font-medium transition-all duration-200 hover:border-transparent hover:bg-indigo-500 hover:text-white"
								}
							>
								Trop difficile
							</button>
						</div>
					</div>

					<h3 className="self-start text-2xl font-semibold underline">
						Impact de la formation
					</h3>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor=""
						>
							Cette formation a t-elle accrue votre efficacité ?
						</label>
						<div className="mt-3 flex items-center">
							<Rating
								showTooltip={true}
								transition={true}
								tooltipArray={tooltipArr}
								tooltipDefaultText="Votre réponse"
								onClick={rate => setRating(rate)}
								ratingValue={rating}
								fillColorArray={[
									"#f17a45",
									"#f19745",
									"#f1a545",
									"#f1b345",
									"#f1d045",
								]}
							/>
						</div>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor=""
						>
							La formation a t-elle accrue votre valeur sur le
							marché du travail (interne ou externe) ?
						</label>
						<div className="mt-3 flex items-center">
							<Rating
								showTooltip={true}
								transition={true}
								tooltipArray={tooltipArr}
								tooltipDefaultText="Votre réponse"
								onClick={rate => setRating2(rate)}
								ratingValue={rating2}
								fillColorArray={[
									"#f17a45",
									"#f19745",
									"#f1a545",
									"#f1b345",
									"#f1d045",
								]}
							/>
						</div>
					</div>

					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor="utiles"
						>
							Quels sont avec le recul les éléments les plus
							utiles de la formation ?
						</label>
						<textarea
							value={elementsUtiles}
							onChange={e => setElementsUtiles(e.target.value)}
							name="utiles"
							id="utiles"
							placeholder="Eléments les plus utiles de la formation"
							className="mt-1 max-h-[250px] min-h-[150px] w-full rounded-md border border-gray-400/50 bg-white p-3 shadow-md outline-none dark:bg-gray-700 dark:text-white"
						/>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor="prolongements"
						>
							Quels pourraient être les prolongements nécessaires
							à la formation ?
						</label>
						<textarea
							value={prolongements}
							onChange={e => setProlongements(e.target.value)}
							name="prolongements"
							id="prolongements"
							placeholder="Prolongements nécessaires
							à la formation"
							className="mt-1 max-h-[250px] min-h-[150px] w-full rounded-md border border-gray-400/50 bg-white p-3 shadow-md outline-none dark:bg-gray-700 dark:text-white"
						/>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor="remarques"
						>
							Autres remarques
						</label>
						<textarea
							value={remarques}
							onChange={e => setRemarques(e.target.value)}
							name="remarques"
							id="remarques"
							placeholder="Remarques"
							className="mt-1 max-h-[250px] min-h-[150px] w-full rounded-md border border-gray-400/50 bg-white p-3 shadow-md outline-none dark:bg-gray-700 dark:text-white"
						/>
					</div>
					<button
						type="submit"
						className="w-full rounded-md border-2 border-transparent bg-indigo-500 p-3 font-medium text-white transition-all duration-200 hover:border-indigo-500 hover:bg-transparent hover:text-indigo-500"
					>
						Envoyer
					</button>
				</div>
				<div
					className={
						sent
							? "visible-check flex h-[250px] flex-col items-center justify-center opacity-100 transition-all duration-300 ease-in-out"
							: "flex h-[0px] flex-col items-center justify-center overflow-hidden opacity-0 transition-all duration-300 ease-in-out"
					}
				>
					<svg
						className="checkmark"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 52 52"
					>
						<circle
							className="checkmark__circle"
							cx="26"
							cy="26"
							r="25"
							fill="none"
						/>
						<path
							className="checkmark__check"
							fill="none"
							d="M14.1 27.2l7.1 7.2 16.7-16.8"
						/>
					</svg>
					<h4 className="my-7 text-2xl font-medium">
						Merci pour vos réponses!
					</h4>
				</div>
			</form>
		</div>
	);
}
